import { MediaQuestionConfig } from '@gripp/shared-logic';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native-paper';
import { isIdpSourceQuestion } from '../../admin/idpQuestions';
import { QuestionException } from '../shared/questionExceptionHandling';
import {
  RoutineQuestionAdminForm,
  RoutineQuestionAdminFormProps,
} from '../types';
import { themedStyleSheet } from '../../../../../themes/themedStyleSheet';

const i18nPrefix = 'routines.workflow.admin.question';

export const MediaQuestionAdminForm: RoutineQuestionAdminForm<
  MediaQuestionConfig
> = (props: RoutineQuestionAdminFormProps<MediaQuestionConfig>) => {
  const { t } = useTranslation();
  const idpEnabled = !!useWatch({ control: props.control, name: 'idpEnabled' });
  // Mirrors workflowAdminPage's own `hasPinnedIdpSource` check: `isIdpSource`
  // survives an IDP off-toggle (only enforcement stops, see idpQuestions.ts),
  // so this question is only actually locked/pinned while IDP is on too.
  const isLockedIdpSource = idpEnabled && isIdpSourceQuestion(props.config);

  return (
    <>
      {isLockedIdpSource && (
        <Text style={styles.hint}>{t(`${i18nPrefix}.idpSourceImageOnly`)}</Text>
      )}
      <QuestionException {...props} />
    </>
  );
};

const styles = themedStyleSheet((role) => ({
  hint: {
    fontSize: 14,
    lineHeight: 18,
    color: role.textSecondary,
    marginBottom: 20,
  },
}));
